import { render } from "./App.vue?vue&type=template&id=47c6f26c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=47c6f26c&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c6f26c"]])

export default __exports__